<template>
  <section>
    <h2 class="mb-2 font-weight-bold">{{ walletCardBranding.header }}</h2>
    <b-row>
      <b-col cols="4">
        <b-img :src="image" fluid center class="wallet-card-image" alt="" />
      </b-col>
      <b-col cols="8">
        <h3 class="text-dark">{{ walletCardBranding.description }}</h3>
        <b-checkbox id="product-style-personalized-wallet-card" v-model="optInForWalletCard" size="lg" @input="setWalletCardOptIn">
          <h3 class="pt-1" :class="!optInForWalletCard ? 'text-dark' : 'text-primary'">
            {{ walletCardBranding.checkboxDescription }}
          </h3>
        </b-checkbox>
      </b-col>
    </b-row>
  </section>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    walletCardBranding: {
      type: Object,
      required: true,
      default: null,
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      optInForWalletCard: this.value,
    };
  },
  methods: {
    setWalletCardOptIn() {
      this.$emit('input', this.optInForWalletCard);
    },
  },
};
</script>
<style scoped lang="scss"></style>
